<template>
  <v-select
    class="wabident-selector"
    id="product_selector"
    @search="searchProducts"
    @input="change"
    :filterable="false"
    :options="products"
    placeholder="Busca el tratamiento/producto aquí ..."
    v-model="selected_product"
  ></v-select>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      products: [],
      searched_products: [],
      selected_product: null,
    };
  },
  methods: {
    change(val) {
      if (val) {
        this.$emit("input", val.value);
      } else {
        this.$emit("input", null);
      }
    },
    reset() {
      this.products = [];
      this.searched_products = [];
      this.selected_product = [];
    },
    fillSearchedProducts(data) {
      if (!data) {
        this.searched_products = [];
        this.products = [];
        return;
      }

      this.searched_products = data;

      let ps = this.searched_products.map((p) => {
        return {
          label: p.name,
          value: p,
        };
      });

      this.products = ps;
    },
    searchProducts(search, loading = null) {
      if (loading) {
        loading(true);
      }
      axios
        .get("/product", {
          params: {
            size: 100,
            search: search,
          },
        })
        .then((response) => {
          if (loading) {
            loading(false);
          }
          this.fillSearchedProducts(response.data.data);
        })
        .catch((error) => {
          console.log("[ERR] searchProducts:", error);
        })
        .then(() => {
          if (loading) {
            loading(false);
          }
        });
    },
    mounted() {
      this.selected_product = this.value;
    },
  },
};
</script>

<style></style>
